const mainMenuMobil = () => {
	// 1. Move selector languages in menu for mobile
	const relocate = () => {
		const selectorIdiomas = document.getElementById("selector-idiomas-mobil");
		const targetContainer = document.querySelector(
			".wp-block-navigation__responsive-dialog .wp-block-navigation__responsive-container-content"
		);

		if (selectorIdiomas && targetContainer) {
			if (selectorIdiomas.parentElement !== targetContainer) {
				targetContainer.appendChild(selectorIdiomas);
			}
			return true;
		}

		return false;
	};

	if (!relocate()) {
		const observer = new MutationObserver(() => {
			if (relocate()) {
				observer.disconnect();
			}
		});

		observer.observe(document.body || document.documentElement, {
			childList: true,
			subtree: true,
		});
	}

	// 2. Move #main-menu to #auxiliary-header / .header-aux-wrapper on screens <= 1278px
	const getAuxiliarTarget = () => {
		return (
			document.querySelector("#header-auxiliar .header-aux-wrapper") ||
			document.querySelector("#header-auxiliar.header-aux-wrapper") ||
			document.querySelector(".header-aux-wrapper") ||
			document.querySelector("#header-aux-wrapper") ||
			document.querySelector("#header-auxiliar")
		);
	};

	let menuPlaceholder = null;

	const handleMenuPrincipalPosition = () => {
		const menuPrincipal = document.getElementById("menu-principal");
		if (!menuPrincipal) return false;

		const mediaQuery = window.matchMedia("(max-width: 1278px)");
		const auxTarget = getAuxiliarTarget();

		if (!menuPlaceholder && menuPrincipal.parentNode) {
			menuPlaceholder = document.createComment("menu-principal-desktop-placeholder");
			menuPrincipal.parentNode.insertBefore(menuPlaceholder, menuPrincipal);
		}

		if (mediaQuery.matches) {
			if (!auxTarget) return false;
			if (menuPrincipal.parentElement !== auxTarget) {
				auxTarget.appendChild(menuPrincipal);
			}
		} else {
			if (
				menuPlaceholder &&
				menuPlaceholder.parentNode &&
				menuPrincipal.parentElement !== menuPlaceholder.parentElement
			) {
				menuPlaceholder.parentNode.insertBefore(menuPrincipal, menuPlaceholder);
			}
		}

		return true;
	};

	if (!handleMenuPrincipalPosition()) {
		const observerMenu = new MutationObserver(() => {
			if (handleMenuPrincipalPosition()) {
				observerMenu.disconnect();
			}
		});

		observerMenu.observe(document.body || document.documentElement, {
			childList: true,
			subtree: true,
		});
	}

	const mediaQuery = window.matchMedia("(max-width: 1278px)");
	const handleMediaChange = () => {
		handleMenuPrincipalPosition();
	};

	if (typeof mediaQuery.addEventListener === "function") {
		mediaQuery.addEventListener("change", handleMediaChange);
	} else {
		mediaQuery.addListener(handleMediaChange);
	}
};

export { mainMenuMobil };
